import { hydrateWidgets } from '@utils';
import { Nav } from '../../widgets/DVWebNodeNav/Nav';
hydrateWidgets(Nav);
